import {
  WSPage,
  WSPageToolbar,
  WSSelect
} from "@wingspanhq/fe-component-library";
import React, { useCallback } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { Tabs } from "../../../../components/Tabs";
import { PAYROLL_RUNS_YEARS } from "../../constants";
import { useModalRunOffCyclePayroll } from "../../modals/ModalRunOffCyclePayroll";
import {
  routeHelperPayrollRunsDashboard,
  routeHelperPayrollRunsDashboardActivePayrolls,
  routeHelperPayrollRunsDashboardHistory,
  routeHelperPayrollRunsDetails
} from "../../paths";
import { PayrollRunsYear } from "../../types";
import { getDefaultPayrollRunYear } from "../../utils";
import { RoutePayrollRunsActivePayrolls } from "../RoutePayrollRunsActivePayrolls";
import { RoutePayrollRunsHistory } from "../RoutePayrollRunsHistory";

const yearOptions = PAYROLL_RUNS_YEARS.map(year => ({
  label: `${year}`,
  value: `${year}`
}));

export const RoutePayrollRunsDashboard: React.FC = () => {
  const goToDashboard = routeHelperPayrollRunsDashboard.useGoTo();
  const goToDetails = routeHelperPayrollRunsDetails.useGoTo();
  const modalRunOffCyclePayroll = useModalRunOffCyclePayroll();
  const {
    params: { year: currentYear }
  } = routeHelperPayrollRunsDashboard.useData();
  const year = (currentYear || getDefaultPayrollRunYear()) as PayrollRunsYear;

  const handleRunOffCyclePayroll = useCallback(async () => {
    const payroll = await modalRunOffCyclePayroll.open();
    // Open the freshly created run so the user can review/finalize it.
    if (payroll?.id) {
      goToDetails({ year, payrollRunId: payroll.id });
    }
  }, [modalRunOffCyclePayroll, goToDetails, year]);

  return (
    <WSPage>
      <WSPageToolbar
        actions={[
          {
            label: "Manage Wingspan wallet"
          },
          {
            label: "Run off-cycle payroll",
            onClick: handleRunOffCyclePayroll
          },
          {
            label: "Manage payroll settings"
          }
        ]}
        title="Payroll runs"
        titleAfter={
          <WSSelect
            hideClearAction={true}
            mode="single"
            options={yearOptions}
            value={year}
            onChange={year => {
              goToDashboard({
                year: year as PayrollRunsYear
              });
            }}
          />
        }
      />
      <Tabs
        tabs={[
          {
            label: "Active payrolls",
            path: routeHelperPayrollRunsDashboardActivePayrolls.createLocationObject(
              { year }
            ).pathname
          },
          {
            label: "History",
            path: routeHelperPayrollRunsDashboardHistory.createLocationObject({
              year
            }).pathname
          }
        ]}
      />
      <Switch>
        <Route
          component={RoutePayrollRunsActivePayrolls}
          path={routeHelperPayrollRunsDashboardActivePayrolls.path}
        />
        <Route
          component={RoutePayrollRunsHistory}
          path={routeHelperPayrollRunsDashboardHistory.path}
        />

        <Redirect
          from="*"
          to={
            routeHelperPayrollRunsDashboardActivePayrolls.createLocationObject({
              year
            }).pathname
          }
        />
      </Switch>
    </WSPage>
  );
};
